import { useState, useEffect } from 'react';

const API_BASE_URL = process.env.REACT_APP_API_URL || '';

let cachedPromise = null;

// A failed or non-ok fetch is not cached — the next useTags() call retries — so a
// transient network blip doesn't leave the SPA seeing an empty tag vocabulary for
// the rest of the session. Only a successful response is memoized.
// Admin pages that edit this data drop the cache when you navigate away (Layout.jsx), since SPA navigation no longer reloads it.
export function resetTagsCache() { cachedPromise = null; }

function fetchTags() {
  if (!cachedPromise) {
    cachedPromise = fetch(`${API_BASE_URL}/tags`, { credentials: 'include' })
      .then((r) => {
        if (!r.ok) { cachedPromise = null; return {}; }
        return r.json();
      })
      .catch(() => { cachedPromise = null; return {}; });
  }
  return cachedPromise;
}

// Fetch-once, process-cached GET /tags. Returns tags grouped by category
// ({tagsByCategory}), flattened and keyed by id ({tagsById}), and a flat
// array ({allTags}). A category's allow_multiple is the authoritative
// MAX()-reduced value from the API — never the per-tag column.
export default function useTags() {
  const [tagsByCategory, setTagsByCategory] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    fetchTags().then((data) => {
      if (!cancelled) {
        setTagsByCategory(data || {});
        setLoading(false);
      }
    });
    return () => { cancelled = true; };
  }, []);

  const allTags = Object.values(tagsByCategory).flatMap((cat) => (cat && cat.tags) ? cat.tags : []);
  const tagsById = {};
  for (const t of allTags) tagsById[t.id] = t;

  return { tagsByCategory, tagsById, allTags, loading };
}
